import { render, staticRenderFns } from "./ImportacaoFinalizadaDialog.vue?vue&type=template&id=a89c5970&lang=html"
import script from "./ImportacaoFinalizadaDialog.vue?vue&type=script&lang=js"
export * from "./ImportacaoFinalizadaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports